import React from "react";
import "./CareerOpening.scss";

import { Link } from "react-router-dom";
import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";
import Job from "../../assets/images/job.png";

const CareerOpening = () => {
  return (
    <section className="careerOpening" id="join-team">
      <article className="careerOpening__container container">
        <div className="careerOpening__container--contents">
          <h1>
            Current Jobs <span>Openings</span>
          </h1>

          <img
            src={Job}
            alt="job"
            width={200}
            height={201}
            title="Radiksez career image"
          />
          <p>
            At this time, there are no open positions available. Please submit
            your information, and we will contact you when a suitable position
            becomes available.
          </p>
          <Link
            to="https://www.linkedin.com/company/radiksez/"
            className="careerCTA__container--contents-link"
          >
            <button className="career__btn-down ">
              <span> Submit your details</span>
            </button>
            <SideBtn />
          </Link>
        </div>
      </article>
    </section>
  );
};

export default CareerOpening;
